var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6295 4.24549C12.7467 4.3627 12.8125 4.52164 12.8125 4.68737C12.8125 4.85309 12.7467 5.01204 12.6295 5.12924L6.69201 11.0667C6.5748 11.1839 6.41586 11.2497 6.25013 11.2497C6.0844 11.2497 5.92546 11.1839 5.80826 11.0667L2.99576 8.25424C2.88191 8.13636 2.81891 7.97849 2.82034 7.81462C2.82176 7.65074 2.88749 7.49398 3.00337 7.3781C3.11925 7.26222 3.27601 7.19649 3.43988 7.19507C3.60375 7.19365 3.76163 7.25664 3.87951 7.37049L6.25013 9.74112L11.7458 4.24549C11.863 4.12832 12.0219 4.0625 12.1876 4.0625C12.3534 4.0625 12.5123 4.12832 12.6295 4.24549Z",
    fill: "#00B311"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.8d7a795326ce5d232719b0566a99b562.svg";
export { ForwardRef as ReactComponent };